import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-copypreviousmonthpopup',
  templateUrl: './copypreviousmonthpopup.component.html',
  styleUrls: ['./copypreviousmonthpopup.component.scss']
})
export class CopypreviousmonthpopupComponent implements OnInit {
  skipDayForm!: FormGroup;
  availableMonths: any[] = [];

  constructor(
    private fb: FormBuilder, private toastr: ToastrService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CopypreviousmonthpopupComponent>
  ) {}

  ngOnInit() {
    this.generateAvailableMonths();

    this.skipDayForm = this.fb.group({
      targetMonth: ['', Validators.required]
    });
  }




  generateAvailableMonths() {
    const today = new Date();
    const currentMonth = today.getMonth(); // 0-11
    const currentYear = today.getFullYear();

    this.availableMonths = [];

    for (let i = 0; i < 12; i++) {
      const month = (currentMonth + i) % 12;
      const year = currentYear + Math.floor((currentMonth + i) / 12);

      this.availableMonths.push({
        value: `${month + 1}-${year}`, // e.g., 3-2025
        label: `${this.getMonthName(month)} ${year}`
      });
    }
  }


  getMonthName(monthIndex: number) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[monthIndex];
  }

  // ========================  Confirm  ==========================
  confirmSelection() {
    if (this.skipDayForm.invalid) {
      this.skipDayForm.markAllAsTouched();
      return;
    }

    const [month, year] = this.skipDayForm.value.targetMonth.split('-');

    console.log(this.data.selectedTasks);

      const firstTask = this.data.selectedTasks?.[0];

  if (firstTask?.dwmDate) {
    const sourceDate = new Date(firstTask.dwmDate);
    const sourceMonth = sourceDate.getMonth() + 1;
    const sourceYear = sourceDate.getFullYear();

    if (Number(month) === sourceMonth && Number(year) === sourceYear) {
      this.toastr.warning('Cannot copy tasks to same month');
      return;
    }
  }
    // only selected tasks
    const copiedTasks = this.data.selectedTasks.map((task: any) => ({
      empComments: null,
      isCriticalTask: null,
      id: null,
      dwmStatus: null,
      managerId: null,

      dwmYear: Number(year),
      dwmMonth: Number(month),
      dwmActive: task?.dwmActive || null,
      dwmType: task?.dwmType || null,
      dwmFrequency: task?.dwmFrequency?.toUpperCase()?.replace('-', '_') || null,
      userId: task?.userId || null,
      companyId: task?.companyId || null,
      categoryId: task?.categoryId || null,
      fiscalYear: task?.fiscalYear || null,
      timeFrom: task?.timeFrom || null,
      timeTo: task?.timeTo || null,
      actionable: task?.actionable || null,
      isRepetativeTask: task?.isRepetativeTask || null,

      dwmDate: this.updateDateYearMonth(task.dwmDate, Number(year), Number(month)) || null
    }));

    this.dialogRef.close(copiedTasks);
  }

  updateDateYearMonth(dateStr: any, year: any, month: any) {
    const date = new Date(dateStr);
    date.setFullYear(year);
    date.setMonth(month - 1); // JS months are 0-based
    return date.toISOString().split('T')[0];
  }
}
